export const getAnalytics = (txt: string) => ({
  click: {
    eventName: 'sport_searchResult_championshipsEvents_showMore_btn_click',
    data: {
      txt,
    },
  },
});
